function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Buffer } from 'buffer';
import { BlobTypes } from '../enums/blob';
export var convertBlobtoBase64 = function(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
            var base64data = reader.result;
            resolve(base64data);
        };
    });
};
export var jsonToBase64 = function(jsonObj) {
    var str = JSON.stringify(jsonObj);
    return btoa(encodeURIComponent(str));
};
export var isBase64 = function(str) {
    try {
        // Validate base64 encoding using Buffer
        var buffer = Buffer.from(str, 'base64');
        var encoded = buffer.toString('base64');
        return encoded === str;
    } catch (error) {
        return false;
    }
};
export var stringToBase64 = function(str) {
    return Buffer.from(str, 'utf-8').toString('base64');
};
export var base64ToString = function(base64Str) {
    if (isBase64(base64Str)) {
        return Buffer.from(base64Str, 'base64').toString('utf-8');
    }
    return base64Str;
};
export var base64ToJson = function(base64Str) {
    var decodedStr = decodeURIComponent(atob(base64Str));
    return JSON.parse(decodedStr);
};
export var convertFileToBase64 = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _reader_result;
            var base64String = ((_reader_result = reader.result) === null || _reader_result === void 0 ? void 0 : _reader_result.toString().split(',')[1]) || '';
            resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
export var base64ToArrayBuffer = function(base64) {
    // Remove the prefix, if it exists (e.g., 'data:image/png;base64,')
    var base64String = base64.startsWith('data:') ? base64.split(',')[1] // Get the part after the comma
     : base64;
    var binary = atob(base64String);
    var array = new Uint8Array(binary.length);
    for(var i = 0; i < binary.length; i += 1){
        array[i] = binary.charCodeAt(i);
    }
    return array;
};
export var arrayToBlob = function(array, contentType) {
    return new Blob([
        array
    ], {
        type: contentType
    });
};
export var arrayToBlobUrl = function(array) {
    var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'application/pdf';
    var blob = arrayToBlob(array, contentType);
    return URL.createObjectURL(blob);
};
export var base64ToBlobUrl = function(base64) {
    var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'application/pdf';
    var array = base64ToArrayBuffer(base64);
    return arrayToBlobUrl(array, contentType);
};
export var getBlobBase64 = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(file) {
        var blobType, newFile;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            blobType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : BlobTypes.Image;
            newFile = new Blob([
                file
            ], {
                type: blobType
            });
            return [
                2,
                convertBlobtoBase64(newFile)
            ];
        });
    });
    return function getBlobBase64(file) {
        return _ref.apply(this, arguments);
    };
}();
export var decodeBase64 = function(base64) {
    return atob(base64);
};
export var getBlobUrl = function(file) {
    var blobType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : BlobTypes.Image;
    var newFile = new Blob([
        file
    ], {
        type: blobType
    });
    return URL.createObjectURL(newFile);
};
export var arrayBufferToBase64 = function(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = bytes.reduce(function(acc, byte) {
        return acc + String.fromCharCode(byte);
    }, '');
    return btoa(binary);
};
export var arrayBufferToString = function(buffer) {
    var decoder = new TextDecoder('utf-8');
    return decoder.decode(buffer);
};
